export default __webpack_public_path__ + "static/media/screen2.cd56e1cf.webp";